import styled, { css } from 'styled-components';

export const HeroWrapper = styled.div.attrs((props) => (
  (props.sticky) ? {
    style: {
      backgroundColor: `rgba(var(--background-color-rgb), ${props.progress / 100})`,
      marginTop: `${-45 + (45 * props.progress) / 100}px`,
    },
  } : {}))`
  display: flex;
  align-items: stretch;
  align-self: stretch;
  flex-flow: row nowrap;
  flex: 0 0 auto;
  padding: 0 1em 1em;
  position: relative;

  ${(props) => props.sticky
    && css`
      position: sticky;
      top: 0;
      padding: 1em 1em 2em;
      z-index: 9;
    `};
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-self: flex-start;
  position: absolute;
  left: 100px;
  top: 50%;
  transform: ${(props) => `translateY(${-60 + (40 - (40 * props.progress) / 100)}%)`};

  ${(props) => props.bordered
    && css`
      border-bottom: 1px solid var(--border-color);

      &:first-child {
        border-top: 1px solid var(--border-color);
      }
    `}
  ${(props) => props.padded
    && css`
      padding: 0 1em;
    `}
    ${(props) => props.centered
    && css`
      align-items: center;
      justify-content: center;
    `};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;

  background: var(--background-color);

  padding: 1em 0;
  align-self: stretch;

  flex: 1 0 auto;
  overflow: hidden;
  position: relative;

  ${(props) => props.nopadding
    && css`
      padding: 0;
    `}
`;

export const ScrollingContent = styled.div`
  display: flex;
  //align-self: stretch;
  flex-flow: column nowrap;
  flex: 1 0 auto;
  padding: 1em 0;

  ${(props) => props.nopadding
    && css`
      padding: 0;
    `}
  ${(props) => props.sidepadding
    && css`
      padding: 0 1em;
    `}
 
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
`;

export const FooterWrapper = styled.div`
  display: flex;
  align-self: stretch;
  flex-flow: column nowrap;
  padding: 0;

  position: sticky;
  bottom: 0;
  z-index: 9;

  > a {
    display: flex;
  }
`;

export const BookingNavItem = styled.div`
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  flex: 1 0 auto;

  border-bottom: 1px solid var(--border-color);
  padding: 1em;

  &:first-child {
    border-top: 1px solid var(--border-color);
  }

  .icon_start {
    flex: 0 0 auto;
    color: var(--brand-color);
    font-size: 2.5em;
    margin-right: 1rem;
    padding: 0 0.5rem;
  }

  .icon_end {
    color: var(--text-color);
  }
`;

export const BookingNavItemContent = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 auto;
  color: var(--brand-color);
`;

export const BookingNavText = styled.p`
  color: var(--text-color);
  font-size: 0.8em;
  font-weight: 400;
  line-height: 1.4;
  margin: 0;

  & + & {
    margin-top: 0.25em;
  }
  ${(props) => props.answer
    && css`
      font-weight: 400;
      margin-bottom: 1em;
    `}
`;

export const BookingNavTitle = styled(BookingNavText)`
  font-size: 1em;
  font-weight: 400;
`;

export const BookingNavLink = styled.a`
  font-size: 0.9em;
  font-weight: 300;
  text-decoration: none;
  text-transform: uppercase;
`;

export const FooterText = styled.p`
  font-weight: 600;
  margin: 0;
`;

export const FooterTextWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 auto;
`;

export const PageWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 0 auto;
  min-height: 100vh;
`;
